import { MovieClip } from '@play-co/timestep-core/ui';
import { Container } from '../../../odie';
import { SpiderBlockProps } from '../../defs/block';
import { getMatch2AssetPath } from '../../util/assets';
import { blockPositionView } from '../../util/blockTools';

const manifest = () => ({
  movieclip: {
    url: getMatch2AssetPath('blocks/spider'),
    loadMethod: MovieClip.animationLoader,
  },
});

export class SpiderBlockView extends Container {
  public readonly movieclip: MovieClip;

  constructor(props: SpiderBlockProps) {
    super();
    blockPositionView(this, props);
    this.movieclip = new MovieClip({
      superview: this.view,
      url: manifest().movieclip.url,
      scale: 0.9,
    });
    this.playIdle();
  }

  public static assets() {
    return Object.values(manifest());
  }

  public playIdle() {
    this.movieclip.play('ladybug_idle', null, true);
  }

  public playClimb() {
    this.movieclip.play('ladybug_climb', null, true);
  }
}
